export class XMLNode {
    tagName;
    parent;
    children;
    attributes;
    bytes;
    startIndex;
    tagValueProcessor;
    cachedValue;
    constructor(tagName, parent, bytes, tagValueProcessor) {
        this.tagName = tagName;
        this.parent = parent;
        this.children = Object.create(null); //child tags
        this.attributes = Object.create(null); //attributes map
        this.bytes = bytes; //text only
        this.tagValueProcessor = tagValueProcessor;
        this.startIndex = -1;
    }
    append(toAppend) {
        if (this.bytes.length === 0) {
            this.bytes = toAppend;
            return;
        }
        const arrayConcat = new Uint8Array(this.bytes.length + toAppend.length);
        arrayConcat.set(this.bytes);
        arrayConcat.set(toAppend, this.bytes.length);
        this.bytes = arrayConcat;
    }
    get value() {
        if (this.cachedValue === undefined) {
            const value = this.tagValueProcessor(this.bytes, this);
            this.cachedValue = value;
        }
        return this.cachedValue;
    }
    addChild(child) {
        const existing = this.children[child.tagName];
        if (Array.isArray(existing)) {
            existing.push(child);
        }
        else {
            this.children[child.tagName] = [child];
        }
    }
}
//# sourceMappingURL=XMLNode.js.map